module.exports = __webpack_public_path__ + "static/4_2_recommendation_GA-5bd2894720959d2e1e355424f3608327.svg";